module.exports = __webpack_public_path__ + "img/12.d0787e3a.jpg";